import { Dispatch, FC, SetStateAction, useMemo, useState } from 'react';
import { HTHActivityPolygons } from './HTHActivity4Polygons';
import { typeHTHTerritory, typePublicMinistryMonthlyService, typePublicMinistryService } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    completionDate: number;
    day?: number;
    hthTerritory: typeHTHTerritory;
    monthlyService: typePublicMinistryMonthlyService;
    service: typePublicMinistryService;
    setHthTerritories: Dispatch<SetStateAction<typeHTHTerritory[] | null>>;
};

export const HTHActivityTerritory: FC<propsType> = ({ completionDate, day, hthTerritory, monthlyService, service, setHthTerritories }) => {
    const [isShowing, setIsShowing] = useState(false);
    const isDarkMode = useGetIsDarkMode();

    const everyPolygonIsComplete: boolean = useMemo(() =>
        hthTerritory.faces.every(p => p.serviceDates.some(_s => _s.serviceId === service.id))
    , [hthTerritory, service]);

    const setAllHandler = () => {
        if (everyPolygonIsComplete) {
            setHthTerritories(x => x!.map(_t => _t.number === hthTerritory.number ? ({
                ..._t,
                faces: _t.faces.map(_p => ({
                    ..._p,
                    serviceDates: !!_p.serviceDates.map(sm => sm.serviceId).includes(service.id) ?
                        _p.serviceDates.filter(sd => sd.serviceId !== service.id)
                        :
                        _p.serviceDates
                }))
            }) : _t));
        } else {
            setHthTerritories(x => x!.map(_t => _t.number === hthTerritory.number ? ({
                ..._t,
                faces: _t.faces.map(_p => ({
                    ..._p,
                    serviceDates: !!_p.serviceDates.map(sm => sm.serviceId).includes(service.id) ?
                        _p.serviceDates
                        :
                        [...(_p.serviceDates ?? []), { completionDate, serviceId: service.id }]
                }))
            }) : _t));
        }
    }

    return (
        <div className={`${isShowing ? 'border-start border-end border-bottom border-secondary rounded-top' : ''} mt-2 mb-3`}>
            <h6 className={`${isDarkMode ? 'bg-dark border' : 'bg-general-blue text-white'} rounded pointer p-2 my-0`}
                onClick={() => setIsShowing(x => !x)}
            >
                TERRITORIO {hthTerritory.territoryNumber} (completado: {Math.round(hthTerritory.faces.filter(p => p.serviceDates.find(sd => sd.serviceId === service.id)).length * 100 / hthTerritory.faces.length)}%)
            </h6>
            {isShowing &&
                <div className={`${isDarkMode ? '' : 'bg-lightgrey'} py-3 ps-2`}>
                    <p className={'small'}>
                        {!!day ?
                            '*Los territorios marcados de este lado de la herramienta ("Por Día") se harán con las verdaderas fechas de las salidas. Cuando se marcan con el otro lado ("Por Asignación") se usa, en cambio, el último día del mes.'
                            :
                            '*Los territorios marcados de este lado de la herramienta ("Por Asignación") se harán con la fecha del último día del mes. Para marcar con los verdaderos días de las salidas, usar el otro lado ("Por Día").'
                        }
                    </p>
                    <HTHActivityPolygons
                        completionDate={completionDate}
                        day={day}
                        everyPolygonIsComplete={everyPolygonIsComplete}
                        hthTerritory={hthTerritory}
                        monthlyService={monthlyService}
                        service={service}
                        setAllHandler={setAllHandler}
                        setHthTerritories={setHthTerritories}
                    />
                </div>
            }
        </div>
    );
}
